import axios from "axios";
import * as Config from "../../../router/config";
import { lazyServerLogout } from '../../../utils/utils';

const state = {
 me: null, // logged in user data
 auth_checked: false,
 logging_in: false,
 login_timeout: false,
 login_locked: false,
};

const actions = {
 check_login({commit}) {
  return new Promise((resolve, reject) => {
   axios.get(Config.apiPath + 'user/me').then(me => {
    commit('CHECK_LOGIN_OK', me.data);
    resolve();
   }).catch(err => {
    commit('CHECK_LOGIN_FAIL');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    reject(err);
   })
  });
 },
 
 login({commit, dispatch}, payload) {
  commit('LOGGING_IN');
  commit('RESET_CLIENT_INFO');

  return new Promise((resolve, reject) => {
   axios.post(Config.apiPath + 'auth/login', payload).then(res => {
    localStorage.setItem('access_token', res.data.access_token);
    localStorage.setItem('refresh_token', res.data.refresh_token);
    commit('LOGIN_OK', {user: res.data.user});
    resolve();
   }).catch(err => {
    commit('CHECK_LOGIN_FAIL');
    reject(err);
   })
  })
 },
 
 unlock({commit, dispatch}, payload) {
  commit('LOGGING_IN');
  return new Promise((resolve, reject) => {
   axios.post(Config.apiPath + 'auth/token/refresh', payload).then(res => {
    localStorage.setItem('access_token', res.data.access_token);
    localStorage.setItem('refresh_token', res.data.refresh_token);
    commit('LOGIN_OK', {user: res.data.user});
    resolve();
   }).catch(err => {
    commit('CHECK_LOGIN_FAIL');
    reject(err);
   })
  })
 },
 
 revoke_token({commit, dispatch}, id) {
  return new Promise((resolve, reject) => {
   axios.post(Config.apiPath + 'auth/token/revoke', {user_id: id}).then(() => {
    resolve();
   }).catch(err => reject(err.data))
  })
 },

 async clientLogout({ commit, state }) {
  const token = localStorage.getItem('access_token');
  const userId = state.me && (state.me.id || state.me.user_id);

  // best-effort remote cleanup that can fail
  lazyServerLogout(token, userId);

  // clear client state immediately
  try { commit('RESET_CLIENT_INFO'); } catch (_) {}
  commit('LOGOUT_OK');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
 },

 async logout({ commit, state }) {
  const userId = state.me && (state.me.id || state.me.user_id);
  try {
   await axios.post(Config.apiPath + 'auth/logout', { user_id: userId });
  } catch (_) {
   // ignore - continue clearing client
  } finally {
   try { commit('RESET_CLIENT_INFO'); } catch (_) {}
   commit('LOGOUT_OK');
   localStorage.removeItem('access_token');
   localStorage.removeItem('refresh_token');
  }
 }
};

const mutations = {
 LOGGING_IN(state) {
  state.logging_in = true
 },
 
 CHECK_LOGIN_OK(state, user) {
  state.me = user;
  state.auth_checked = true;
  state.logging_in = false;
 },
 
 CHECK_LOGIN_FAIL(state) {
  state.auth_checked = true;
  state.logging_in = false;
  state.login_timeout = false;
  state.login_locked = false;
 },
 
 LOGIN_TIMEOUT(state, payload) {
  state.login_timeout = payload
 },
 
 LOGIN_LOCK(state, payload) {
  state.login_locked = payload
 },
 
 LOGIN_OK(state, {user}) {
  state.me = user;
  state.login_timeout = false;
  state.login_locked = false;
  state.logging_in = false;
 },
 
 LOGOUT_OK(state) {
  state.me = null;
  state.auth_checked = false;
  state.logging_in = false;
  state.login_timeout = false;
  state.login_locked = false;
 }
};

export default {state, actions, mutations}
